import React, { useState, useEffect, Fragment } from "react";
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { CSSTransition } from 'react-transition-group';
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AspectRatioBox from "./aspectRatioUtil";
import TextRow from "./textRow";
import Pagination from "./pagination";
import { getStatic } from '../static';
import { ReactComponent as ArrowUp } from "../static/svg/arrow-white.svg";

import classNames from 'classnames';

import configData from "../config.json";

const PAGE_SIZE = 12;

function getMedia(path) {
  return configData.API_URL + path;
}

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

function sizeOverlay(){
  let colorOverlays = document.getElementsByClassName('colorOverlay');
  for (var i = 0; i < colorOverlays.length; i++) {
    let w = colorOverlays[i].offsetWidth;
    let h = colorOverlays[i].offsetHeight;
    let o = colorOverlays[i].parentElement.getElementsByClassName('overlay')[0];
    o.style.width = w + "px";
    o.style.height = h + "px";
  }
}

function NewsIndex(props) {

    let {categorySlug} = useParams();
    const [loaded, setLoaded] = useState(false);
    const [page, setPage] = useState(1);
    const [objs, setObjs] = useState();
    //  const [data, setData] = useState(null);
    const [categories, setCategories] = useState();
    const [intro, setIntro] = useState();

    const getIntro = async() => {
      await axios({
        method: 'get',
        url: configData.API_URL + "/api/news-intro/"
        })
        .then(response => {
          const dataJSON = response.data;
          setIntro(dataJSON);
        });
    }

    const getCategories = async() => {
      await axios({
        method: 'get',
        url: configData.API_URL + "/api/news-category/"
        })
        .then(response => {
          const dataJSON = response.data;
          setCategories(dataJSON);
        });
    }



    const getObjs = async(path) => {
      await axios({
        method: 'get',
        url: configData.API_URL + path
        })
        .then(response => {
          const dataJSON = response.data;
          setObjs(dataJSON);
          setPage(dataJSON.current_page);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
    
  useEffect(() => {
    let path = categorySlug ? `/api/news/?search=${categorySlug}&page=${page}&page_size=${PAGE_SIZE}` : `/api/news?page=${page}&page_size=${PAGE_SIZE}`;
    getObjs(path);
    getCategories();
  }, [page, categorySlug]);

    useEffect(() => {
      let rowTl;
      if (objs) {
        objs.results.forEach((o, i) => {
           let rowTl = gsap.timeline({
            defaults: {
              duration: 0.6, 
              ease: "power1",
            },
            scrollTrigger: {
              trigger: "#triggerCaseId_" + o.id,
              start: "top 80%",
              end: "+=100",
              scrub: 1,
              markers: false
            }
          });
         rowTl.fromTo("#newsId_" + o.id, {translateY: "40px"}, {translateY: "0"});
         rowTl.fromTo("#newsId_" + o.id, {opacity: 0}, {opacity: 1},"<");
        });

      }
      // return () => {
      //   rowTl && rowTl.kill();
      // }
    }, [objs])

    useEffect(() => {
        if (objs) {
            setLoaded(true);
            console.log('news loaded');
            console.log('news', objs)
        }
    }, [objs])

    useEffect(() => {
      props.menuColor('none');
      props.accentColor('#FFFFFF');
      // props.logoColor('fillBlack');
      // Page Meta
      document.title = ""
      document.querySelector('meta[name="description"]').setAttribute("content", "");
      document.documentElement.scrollTop = 0;

      // Load Content
      let path = categorySlug ? `/api/news/?search=${categorySlug}` : `/api/news`;
      getObjs(path);
      getIntro();
      getCategories();
    }, []);



  return (
      <CSSTransition in={loaded} timeout={200} unmountOnExit classNames="pageItem">
         <div id="content" className="newsIndex">
          <div id="newsIndex" className="column">
          <span className="row" id="row0">
            <div className="anim1 landing">

              {intro && <TextRow fonts={true} h1={intro.text} h2={intro.subheading} h3={null} p={null} readmore={intro.text_more} /> }      

            </div>

          </span>
          {categories && <div className="newsSubNav row flex0 gap10" style={{display: "none"}}>
            <Link to={'/news'} style={{width: (3 * 16) + 'px'}} className={classNames("newsSub", { "on": !categorySlug })}><h2>All</h2></Link>
            {categories.map((cat, i) => (
              <Link to={'/news/' + cat.slug} 
              style={{width: (cat.heading.length * 16) + 'px'}}
              className={classNames("newsSub", { "on": categorySlug === cat.slug })} key={'cat_' + i}><h2>{cat.heading}</h2>
            
              </Link>
            ))}
          </div>}
            <div className="grid grid3">
            {objs && objs.results.map((obj, i) => (
   
                <a href={obj.link ? obj.link : obj.get_absolute_url}
                key={'news_' + i}
                id={'newsId_' + obj.id}
                className={"item newsIndexBox"}
              
                rel={"noreferrer"}
                target={obj.link ? "_blank" : "_self"}
                >
                <span className="newsImage">
                <img src={props.isMobile?getMedia(obj.thumbnail_m ? obj.thumbnail_m : obj.thumbnail):getMedia(obj.thumbnail)} alt={obj.image_alt} />
                </span>
                
                       <span className="newsText">
                      <p>{obj.category && <strong style={{display: "none"}}>{obj.category.heading}</strong>} {obj.intro}</p>
                    </span>
               
              </a>
            
            ))}
            </div>
             {objs && objs.total_pages > 1 ? <Pagination
            currentPage={objs.current_page}
            totalPages={objs.total_pages}
            onPageChange={setPage}
          /> : <span style={{height: "100px", display: "block"}}></span>}
          </div>
         
        </div>
      </CSSTransition>
  );
}

export default NewsIndex;


